import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCountry12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCountry12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Country12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6 11.143a5.1 5.1 0 0 0 1.572-.245v-1.22H6.5A1.43 1.43 0 0 1 5.072 8.25V5.748l.22-.123 4.28-2.377V2.3a5.1 5.1 0 0 0-1.893-1.163v2.128l-.237.118-1 .5-.242.121-.213-.166-1.558-1.212v2.079c0 .789-.64 1.428-1.429 1.428H1a.4.4 0 0 1-.142-.024A5.143 5.143 0 0 0 6 11.143M.906 5.286A.4.4 0 0 1 1 5.276h2a.57.57 0 0 0 .572-.571v-3.24A5.15 5.15 0 0 0 .906 5.286m3.139-4.044a5.13 5.13 0 0 1 2.777-.32v1.813l-.522.261-2.037-1.584zM8.429 9.25v1.284a5.14 5.14 0 0 0 2-7.15v.368l-.22.123-4.28 2.377V8.25a.57.57 0 0 0 .571.571h1.93zM6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Country12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconCountry12);
